import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import thresholdGroupAxios from '../../axios/thresholdGroup'

export const fetchThresholdGroup = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchThresholdGroupStart())
    thresholdGroupAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchThresholdGroupSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchThresholdGroupFailed(error))
      })
  }
}

export const fetchThresholdGroupStart = () => {
  return {
    type: actionTypes.FETCH_THRESHOLD_GROUP_START
  }
}

export const fetchThresholdGroupSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_THRESHOLD_GROUP_SUCCESS,
    pagination,
    records
  }
}

export const fetchThresholdGroupFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_THRESHOLD_GROUP_FAILED,
    errorMessage
  }
}

export const fetchThresholdGroupById = recordId => {
  return dispatch => {
    dispatch(fetchThresholdGroupStart())
    thresholdGroupAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchThresholdGroupByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchThresholdGroupFailed(error))
      })
  }
}

export const fetchThresholdGroupByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_THRESHOLD_GROUP_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedThresholdGroupRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_THRESHOLD_GROUP_RECORD
  }
}

export const createThresholdGroup = (recordData, page) => {
  return dispatch => {
    dispatch(createThresholdGroupStart())

    thresholdGroupAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'ThresholdGroup Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createThresholdGroupSuccess())
          dispatch(fetchThresholdGroup(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid ThresholdGroup field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            if (error?.response?.status !== 500) {
              dispatch(
                enqueueSnackbar({
                  message: error.response.data.message,
                  options: {
                    variant: 'error'
                  }
                })
              )
            }
            break
        }
        dispatch(createThresholdGroupFailed())
      })
  }
}

export const createThresholdGroupStart = () => {
  return {
    type: actionTypes.CREATE_THRESHOLD_GROUP_START
  }
}

export const createThresholdGroupSuccess = () => {
  return {
    type: actionTypes.CREATE_THRESHOLD_GROUP_SUCCESS
  }
}

export const createThresholdGroupFailed = () => {
  return {
    type: actionTypes.CREATE_THRESHOLD_GROUP_FAILED
  }
}

export const updateThresholdGroup = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateThresholdGroupStart())
    thresholdGroupAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'ThresholdGroup Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateThresholdGroupSuccess())
        dispatch(fetchThresholdGroup(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid ThresholdGroup field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            if (error?.response?.status !== 500) {
              dispatch(
                enqueueSnackbar({
                  message: error.response.data.message,
                  options: {
                    variant: 'error'
                  }
                })
              )
            }
            break
        }
        dispatch(updateThresholdGroupFailed())
      })
  }
}

export const updateThresholdGroupStart = () => {
  return {
    type: actionTypes.UPDATE_THRESHOLD_GROUP_START
  }
}

export const updateThresholdGroupSuccess = () => {
  return {
    type: actionTypes.UPDATE_THRESHOLD_GROUP_SUCCESS
  }
}

export const updateThresholdGroupFailed = () => {
  return {
    type: actionTypes.UPDATE_THRESHOLD_GROUP_FAILED
  }
}

export const deleteThresholdGroup = (recordId, page) => {
  return dispatch => {
    dispatch(deleteThresholdGroupStart())
    thresholdGroupAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'ThresholdGroup Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteThresholdGroupSuccess())
        dispatch(fetchThresholdGroup(page))
      })
      .catch(error => {
        if (error?.response?.status !== 500) {
          dispatch(
            enqueueSnackbar({
              message: error.response.data.message,
              options: {
                variant: 'error'
              }
            })
          )
        }
        dispatch(deleteThresholdGroupFailed())
      })
  }
}

export const deleteThresholdGroupStart = () => {
  return {
    type: actionTypes.DELETE_THRESHOLD_GROUP_START
  }
}

export const deleteThresholdGroupSuccess = () => {
  return {
    type: actionTypes.DELETE_THRESHOLD_GROUP_SUCCESS
  }
}

export const deleteThresholdGroupFailed = () => {
  return {
    type: actionTypes.DELETE_THRESHOLD_GROUP_FAILED
  }
}

export const fetchThresholdGroupFilterThresholdGroup = filter => {
  return dispatch => {
    dispatch(fetchThresholdGroupFilterThresholdGroupStart())
    thresholdGroupAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchThresholdGroupFilterThresholdGroupSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchThresholdGroupFilterThresholdGroupFailed(error?.response?.data?.message))
      })
  }
}

export const fetchThresholdGroupFilterThresholdGroupStart = () => {
  return {
    type: actionTypes.FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_START
  }
}

export const fetchThresholdGroupFilterThresholdGroupSuccess = data => {
  return {
    type: actionTypes.FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_SUCCESS,
    data
  }
}

export const fetchThresholdGroupFilterThresholdGroupFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_FAILED,
    errorMessage
  }
}
